/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Sugglanguage1Inputs */

const zh_landing_copilot_sugglanguage1 = /** @type {(inputs: Landing_Copilot_Sugglanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言教学`)
};

const en_landing_copilot_sugglanguage1 = /** @type {(inputs: Landing_Copilot_Sugglanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language Teaching`)
};

const es_landing_copilot_sugglanguage1 = /** @type {(inputs: Landing_Copilot_Sugglanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseñanza de idiomas`)
};

/**
* | output |
* | --- |
* | "Language Teaching" |
*
* @param {Landing_Copilot_Sugglanguage1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_copilot_sugglanguage1 = /** @type {((inputs?: Landing_Copilot_Sugglanguage1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Sugglanguage1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_sugglanguage1(inputs)
	if (locale === "en") return en_landing_copilot_sugglanguage1(inputs)
	return es_landing_copilot_sugglanguage1(inputs)
});
export { landing_copilot_sugglanguage1 as "landing_copilot_suggLanguage" }